import { ReactElement } from 'react';
import { DrawerPanel } from '@dmc/ui';
import { SafetyAlertModel } from '@casops/store/apis/personnelSafetyApi';
import { SafetyAlertHeader } from '../components/header/SafetyAlertHeader';
import { SafetyAlertMap } from '@casops/components/maps/safety-alert-map/SafetyAlertMap';
import { AcknowledgedStatement } from '../components/acknowledged-statement/AcknowledgedStatement';
import styles from './SafetyAlertViewerView.module.scss';

interface SafetyAlertViewerViewProps {
  item: SafetyAlertModel;
}

export function SafetyAlertViewerView({ item }: SafetyAlertViewerViewProps): ReactElement {
  return (
    <DrawerPanel header={<SafetyAlertHeader model={item} />}>
      <div className={styles.view}>
        <SafetyAlertMap item={item} />
        {item.ack && <AcknowledgedStatement ackAt={item.ackAt} ackBy={item.ackBy} />}
      </div>
    </DrawerPanel>
  );
}

export default SafetyAlertViewerView;
